import React from 'react'

export default class extends React.Component {
  render () {
    return <div style={{ width: 480, height: '100vh', position: 'relative', padding: 20, textAlign: 'justify', background: '#F7F7F7' }}>

      <h6>Bonjour,</h6>
      <p>A l’occasion de cette nouvelle année, toute l’équipe Euresto vous remercie pour votre confiance renouvelée, et
        vous souhaite réussite, prospérité, et enthousiasme pour 2019.<br/><br/>
        2018 a été une année de transition pour Euresto, nous avons restructuré nos services et espérons que cela aura
        un effet positive sur nos relations clientèles pour les années à venir.</p>
      <div style={{ position: 'absolute', left: 20, background: '#002E42', width: 400, padding: 20, color: 'white' }}>
        <div style={{position: 'absolute', top: -13, zindex: 1, background: '#5DA4F0', padding: 5}}><h5 style={{marginBottom: 0}}>Nouveautés 2018</h5></div>
        A l’occasion de la sortie de la nouvelle version Euresto prévue pour fin janvier 2019, nous reviendrons vers
        vous pour vous en détailler toutes les améliorations et nouveautés.
        Notons outre le changement graphique, et l’orientation accentuée vers plus de modules web, les améliorations
        faites sur la réservation restaurant qui s’enrichit d’une gestion de stock de tables et
        de la possibilité d’effectuer des réservations fermes.
        <br/>
        <br/>
        De nouveaux services arrivent en cette nouvelle année, le déploiement systématisé d’un outil de sauvegarde
        cloud, et de nouveaux outils de protection pour éviter que votre système ne soit victime de virus ou de
        ramsomware.
        <br/>
        <br/>
        <div style={{ width: 200 }}>
          En juin prochain nous renouvèlerons notre certificat NF-525, qui fera l’objet d’une nouvelle version dès la
          rentrée de septembre 2019
        </div>
      </div>

      <div
        style={{
          position: 'absolute',
          background: '#002E42',
          left: 20,
          width: 400,
          padding: 20,
          zIndex: 1,
          top: 489,
          color: 'white'
        }}>
        <div style={{position: 'absolute', top: -13, zindex: 1, background: '#5DA4F0', padding: 5}}><h5 style={{marginBottom: 0}}>Statistiques</h5></div>
        <div style={{ width: 200 }}>
          Une quarantaine de nouveaux clients a rejoint en 2018 les utilisateurs d’Euresto, et nous sommes très fiers
          d’avoir pu les accompagner et les aider dans leur équipement informatique et logiciel.
        </div>
        <br/>
        <br/>
        Notons 15 nouveaux lycées en France et Outre-mer qui ont également fait le choix de nos solutions de gestion
        et
        de facturation pour leurs établissements privés ou publiques.
      </div>

      <div
        style={{
          position: 'absolute',
          background: '#009f8c',
          width: 200,
          right: 30,
          padding: 20,
          zIndex: 2,
          top: 340,
          color: 'white'
        }}>
        <div style={{position: 'absolute', top: -13, zindex: 1, background: '#5DA4F0', padding: 5, width: 160, textAlign: 'center'}}><h5 style={{marginBottom: 0}}>Nouveautés 2019</h5></div>
        L’objectif pour 2019 est d’être au plus près de nos clients et utilisateurs, nous allons pour cela
        développer
        notre communication et organiser des rencontres sur site, dans nos grandes régions. Nous ne manquerons pas
        de
        vous donner les dates de ces rendez-vous, qui seront l’occasion de nous connaître davantage, de partager nos
        expériences Euresto et de découvrir de nouvelles fonctionnalités.
      </div>

    </div>
  }
}



// WEBPACK FOOTER //
// ./app/App/Module/Page/Page/Voeux/index.js